export enum EncounterStepType {
  quiz = 'quiz',
  dialogue = 'dialogue',
  action = 'action',
  plot = 'plot',
  roll = 'roll',
}

export enum PrimaryCharacteristics {
  strength = 'strength',
  agility = 'agility',
  intellect = 'intellect',
  oratory = 'oratory',
  imagination = 'imagination',
}

export enum SecondaryCharacteristics {
  pressure = 'pressure',
  stamina = 'stamina',
  stature = 'stature',

  coordination = 'coordination',
  speed = 'speed',
  reaction = 'reaction',

  erudition = 'erudition',
  wisdom = 'wisdom',
  intuition = 'intuition',

  clearness = 'clearness',
  understanding = 'understanding',
  evocation = 'evocation',

  worldSense = 'worldSense',
  conceptualization = 'conceptualization',
  creativity = 'creativity',
}

export type Characteristics = PrimaryCharacteristics | SecondaryCharacteristics;

export const isCharacteristicPrimary = (characteristic: Characteristics): boolean => {
  return Object.values(PrimaryCharacteristics).includes(characteristic as PrimaryCharacteristics);
}
